import { Bot } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const smartbotManifest: ModuleDefinition = {
  id: 'smartbot',
  name: 'SMART-bot',
  icon: <Bot size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/smart-bot',
  status: 'active',
  navItems: [
    { label: 'SMART-bot', path: '/smart-bot', icon: '' },
  ],
  component: () => import('./index.js'),
};

export default smartbotManifest;
